import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogOut } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { useAdmin } from "../context/AdminContext";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { isAdmin, login, logout } = useAdmin();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    
    const success = await login(password);
    
    if (success) {
      navigate("/");
    } else {
      setError("Mot de passe incorrect");
    }
    setLoading(false);
  };

  if (isAdmin) {
    return (
      <div className="min-h-screen bg-neutral-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-sm text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-green-600" />
          </div>
          <h1 className="text-2xl font-bold mb-2 font-['Oswald']">Mode Admin Actif</h1>
          <p className="text-neutral-500 mb-6 text-sm">
            Vous pouvez modifier les cartes directement en cliquant sur les produits.
          </p>
          
          <div className="space-y-3">
            <Button 
              onClick={() => navigate("/")} 
              className="w-full bg-amber-500 hover:bg-amber-600"
            >
              Aller aux cartes
            </Button>
            <Button 
              onClick={logout} 
              variant="outline"
              className="w-full"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Déconnexion
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-sm">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Lock className="w-8 h-8 text-amber-600" />
        </div>
        <h1 className="text-2xl font-bold text-center mb-2 font-['Oswald']">Administration</h1>
        <p className="text-neutral-500 text-center mb-6 text-sm">
          Connectez-vous pour modifier les cartes
        </p>
        
        <form onSubmit={handleLogin} className="space-y-4">
          <Input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full"
          />
          
          {error && (
            <p className="text-red-500 text-sm text-center">{error}</p>
          )}
          
          <Button 
            type="submit" 
            className="w-full bg-amber-500 hover:bg-amber-600"
            disabled={loading}
          >
            {loading ? "Connexion..." : "Connexion"}
          </Button>
        </form>
        
        <Button 
          variant="ghost" 
          className="w-full mt-4"
          onClick={() => navigate("/")}
        >
          Retour aux cartes
        </Button>
      </div>
    </div>
  );
}
